@for (outcome of outcomes; track outcome) {
    <div class="round" [ngClass]="outcome.toLowerCase()"></div>
}

<div class="timeline-arrow"></div>
